// extracted by mini-css-extract-plugin
module.exports = {"container":"title-module--container--2iTTE","heading":"title-module--heading--1_rAi","tagline":"title-module--tagline--1u1Ci","logoContainer":"title-module--logoContainer--GYZ0D"};